import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmationDialog } from 'app/components';
import { translations } from 'locales/i18n';

interface ApproveDialogProps {
  open: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export const ApproveDialog = ({ open, handleClose, onConfirm }: ApproveDialogProps) => {
  const { t } = useTranslation();
  return (
    <ConfirmationDialog
      open={open}
      title={t(translations.pages.billingFinance.confirmationDialog.approveTitle())}
      onClose={handleClose}
      onConfirm={onConfirm}
    >
      {t(translations.pages.billingFinance.confirmationDialog.approveDialog())}
    </ConfirmationDialog>
  );
};
